module.exports = __webpack_public_path__ + "img/pwa-install-popup-bg.fac80b62.png";